import { WppIconChevron } from '@wppopen/components-library-react'
import styles from './BackNavigationButton.module.scss'
import { Link } from 'react-router-dom'
import clsx from 'clsx'

interface BackNavigationButtonProps {
  href: string
  text?: string
  isBottomMargin?: boolean
}

function BackNavigationButton({ href, text = 'Back', isBottomMargin = true }: BackNavigationButtonProps) {
  return (
    <Link
      to={href}
      className={clsx(styles.link, { [styles.margin_bottom]: isBottomMargin })}
      data-testid="back-navigation-link"
    >
      <WppIconChevron direction="left" data-testid="back-navigation-icon" />
      {text}
    </Link>
  )
}

export default BackNavigationButton
